import { z } from 'zod';
export const studioMarketingSchema = z.object({
  launch: z.string().min(20).max(3000),
  socialPosts: z.array(z.string().min(10).max(1500)).min(2).max(5),
  emails: z.array(z.object({ subject: z.string().min(3).max(150), body: z.string().min(20).max(3000) }).strict()).min(1).max(3),
  pricingRationale: z.string().min(10).max(1000),
}).strict();
export const studioListingSchema = z.object({
  subtitle: z.string().min(3).max(180), targetAudience: z.string().min(5).max(500),
  language: z.string().min(2).max(60), softwareRequirements: z.string().min(5).max(500),
  usageInstructions: z.string().min(20).max(2000), tags: z.array(z.string().min(2).max(60)).min(2).max(12),
  seoTitle: z.string().min(3).max(70), seoDescription: z.string().min(20).max(170),
  faqs: z.array(z.object({ question: z.string().min(5).max(200), answer: z.string().min(10).max(1000) }).strict()).min(2).max(5),
}).strict();
export const studioProductSchema = z.object({
  title: z.string().trim().min(3).max(120), description: z.string().trim().min(30).max(4000), shortDescription: z.string().trim().min(3).max(240),
  category: z.string().trim().min(2).max(80), price: z.number().min(0).max(10000), currency: z.literal('EUR'),
  format: z.enum(['guide', 'workbook', 'planner', 'checklist', 'templates']), features: z.array(z.string().min(2).max(160)).min(2).max(8),
  color: z.string().regex(/^#[a-fA-F0-9]{6}$/), accent: z.string().regex(/^#[a-fA-F0-9]{6}$/),
  sections: z.array(z.object({ title: z.string().min(2).max(120), body: z.string().min(80).max(5000) }).strict()).min(3).max(12),
  marketing: studioMarketingSchema.optional(),
  listing: studioListingSchema.optional(),
}).strict();
export const studioReplySchema = z.discriminatedUnion('phase', [
  z.object({ phase: z.literal('question'), message: z.string().min(3).max(700), summary: z.array(z.string().min(3).max(180)).max(3), question: z.string().min(3).max(300), suggestions: z.array(z.string().min(1).max(120)).max(4) }).strict(),
  z.object({ phase: z.literal('ready'), message: z.string().min(3).max(700), summary: z.array(z.string().min(3).max(180)).max(3), products: z.array(studioProductSchema).min(1).max(3) }).strict(),
]);
export type StudioProduct = z.infer<typeof studioProductSchema>;
export type StudioReply = z.infer<typeof studioReplySchema>;
export type StudioMessage = { role: 'user' | 'assistant'; content: string };
